"use client";

import { c as _c } from "react/compiler-runtime";
import { zodResolver } from "@hookform/resolvers/zod";
import { CenterAligned, classNames, Form, FormControl, Input, Spinner } from "@opensea/ui-kit";
import { ArrowForward } from "@opensea/ui-kit/icons";
import { useForm, useFormState } from "react-hook-form";
import { useTranslations } from "use-intl";
import { z } from "zod";
import { Button } from "../../../../../components/Button";
import { useIsFormSubmitDisabled } from "../../../../../lib/form/valid";
import { emailSchema } from "../../../../../lib/zod/schema";
const formSchema = z.object({
  email: emailSchema
});
export const EmailInputStep = t0 => {
  const $ = _c(35);
  const {
    onSubmit,
    initialEmail
  } = t0;
  const t = useTranslations("wallet.EmailInputStep");
  const t1 = initialEmail || "";
  let t2;
  if ($[0] !== t1) {
    t2 = {
      email: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = zodResolver(formSchema);
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t2) {
    t4 = {
      defaultValues: t2,
      resolver: t3,
      mode: "onSubmit"
    };
    $[3] = t2;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const {
    register,
    handleSubmit,
    control
  } = useForm(t4);
  let t5;
  if ($[5] !== control) {
    t5 = {
      control
    };
    $[5] = control;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const {
    errors,
    isSubmitting
  } = useFormState(t5);
  const isFormSubmitDisabled = useIsFormSubmitDisabled(control);
  let t6;
  if ($[7] !== onSubmit) {
    t6 = async data => {
      await onSubmit(data.email);
    };
    $[7] = onSubmit;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const handleFormSubmit = t6;
  let t7;
  if ($[9] !== handleFormSubmit || $[10] !== handleSubmit) {
    t7 = handleSubmit(handleFormSubmit);
    $[9] = handleFormSubmit;
    $[10] = handleSubmit;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = errors.email?.message;
  let t9;
  if ($[12] !== t) {
    t9 = t("emailLabel");
    $[12] = t;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = classNames("h-14 rounded-xl bg-bg-primary pr-3");
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== isSubmitting) {
    t11 = isSubmitting ? <CenterAligned className="size-5"><Spinner color="white" size="xs" /></CenterAligned> : ArrowForward;
    $[15] = isSubmitting;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== isFormSubmitDisabled || $[18] !== t11) {
    t12 = <Button disabled={isFormSubmitDisabled} icon={t11} size="sm" type="submit" />;
    $[17] = isFormSubmitDisabled;
    $[18] = t11;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t) {
    t13 = t("emailPlaceholder");
    $[20] = t;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== register) {
    t14 = register("email");
    $[22] = register;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t12 || $[25] !== t13 || $[26] !== t14) {
    t15 = <Input className={t10} endEnhancer={t12} placeholder={t13} {...t14} />;
    $[24] = t12;
    $[25] = t13;
    $[26] = t14;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t15 || $[29] !== t8 || $[30] !== t9) {
    t16 = <FormControl error={t8} hideLabel={true} label={t9}>{t15}</FormControl>;
    $[28] = t15;
    $[29] = t8;
    $[30] = t9;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t16 || $[33] !== t7) {
    t17 = <Form onSubmit={t7}>{t16}</Form>;
    $[32] = t16;
    $[33] = t7;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  return t17;
};